<template>
  <q-date
    v-model="date"
    color="primary"
    class="full-width"
    minimal
    today-btn
    :locale="locale"
    :options="getOptions"
  />
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import { constants } from 'quasar-pilot-core/src/lib/constants';
import { date } from 'quasar';
import timestamp from 'quasar-pilot-core/src/mixins/format/timestamp';

function padZero(number) {
  if (number < 10) {
    return `0${number}`;
  }
  return number;
}
const getDate = () => new Date();
const getHour = () => padZero(getDate().getHours());

export default {
  name: 'CateringDatePicker',
  mixins: [timestamp],

  props: {
    location: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      date: '',
      locale: constants.DATE_LOCALE_OPTIONS,
      hour: getHour(),
      openingHours: null,
      startDate: null,
      disabledDates: [],
    };
  },

  computed: {
    ...mapState('order', ['orderDate']),
  },

  watch: {
    date() {
      const d = new Date(this.date);
      if (this.orderDate) {
        d.setHours(this.orderDate.getHours());
        d.setMinutes(this.orderDate.getMinutes());
      }
      this.updateOrderDate({ date: d });
    },
  },

  async created() {
    if (this.location && !this.openingHours) {
      this.openingHours = await this.fetchOpeningHours({ locationId: this.location.id });
      this.generateDisabledDates();
    }

    this.date = this.orderDate ?? '';
    this.generateStartDate();
  },

  methods: {
    ...mapActions('location', ['fetchOpeningHours']),
    ...mapMutations('order', ['updateOrderDate']),

    generateStartDate() {
      this.startDate = date.formatDate(date.addToDate(new Date(), {
        days: this.checkTime(),
      }), 'YYYY/MM/DD');
    },

    generateDisabledDates() {
      if (this.openingHours?.length) {
        const now = new Date();
        this.openingHours.forEach((openingHour) => {
          if (!openingHour.days?.length) {
            let begins = new Date(openingHour.periodStart * 1000);
            const ends = new Date(openingHour.periodEnd * 1000);

            // Only add future dates
            while (begins <= ends) {
              if (begins > now) {
                this.disabledDates.push(date.formatDate(begins, 'YYYY/MM/DD'));
              }
              begins = date.addToDate(begins, { days: 1 });
            }
          }
        });
      }
    },

    getOptions(d) {
      return (d >= this.startDate && !this.disabledDates.includes(d));
    },

    checkTime() {
      let days = 1;
      const dateNow = new Date();
      // If time is 13:00 or over, deliveryTime is set to min 2 days
      if (this.hour >= 13) {
        days = 2;
      }
      // Thursday to Sunday -> Pickup is only available on Monday
      if ((dateNow.getDay() >= 4 && dateNow.getDay() <= 6) || dateNow.getDay() === 0) {
        // Thursday after 13:00, pickup on Monday
        if (dateNow.getDay() === 4 && this.hour >= 13) {
          days = 5;
        }
        // Friday
        if (dateNow.getDay() === 5) {
          days = 4;
        }
        // Saturday
        if (dateNow.getDay() === 6) {
          days = 3;
        }
        // Sunday
        if (dateNow.getDay() === 0) {
          days = 2;
        }
      }
      return days;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.q-date__view) {
  padding: 0;
}

:deep(.q-date__navigation) {
  background: black;
  color: white;
  padding: 5px;
  button {
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 26px;
  }
}

:deep(.q-date__calendar-weekdays),
:deep(.q-date__calendar-days-container) {
  padding: 0 16px;
}

:deep(.q-date__calendar-days-container) {
  padding-bottom: 15px;
}

:deep(.q-date__calendar-weekdays) {
  padding-top: 15px;
  margin-bottom: 10px;
  border-bottom: 1px solid #E0E0E0;
}

:deep(.q-date__calendar-weekdays .q-date__calendar-item) {
  opacity: 1;
  font-size: 16px;
  text-transform: uppercase;
  font-weight: 600;
}
</style>
